export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-1d852a2261dea4fd9535.worker.js");
}